// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.6_webpack@5.101.2/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-body {
    font-family: "Inter", sans-serif;
  }

.sign-up-container::before {
  content: "";
  display: block;
  background-repeat: no-repeat;
  width: 48px;
  height: 48px;
  margin-left: 50%;
  transform: translateX(-50%);
}

.sign-up-container {
  max-width: 360px;
  margin: 0 auto;
  padding: 20px;
}

.sign-up-container h2 {
  text-align: center;
  letter-spacing: 1px;
  margin-bottom: 30px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 38px;
}

.sign-up-container h3 {
  color: var(--second-text-color);
  text-align: center;
  margin-bottom: 30px;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginComponents/signup.css"],"names":[],"mappings":"AAEA;IACI,gCAAgC;EAClC;;AAEF;EACE,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["@import url(./variables.css);\n\n.sign-up-body {\n    font-family: \"Inter\", sans-serif;\n  }\n\n.sign-up-container::before {\n  content: \"\";\n  display: block;\n  background-repeat: no-repeat;\n  width: 48px;\n  height: 48px;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.sign-up-container {\n  max-width: 360px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.sign-up-container h2 {\n  text-align: center;\n  letter-spacing: 1px;\n  margin-bottom: 30px;\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 38px;\n}\n\n.sign-up-container h3 {\n  color: var(--second-text-color);\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
